module.exports = __webpack_public_path__ + "img/knowledge_folder_icon_list.4ee76320.svg";